import { render } from "./v-loading.vue?vue&type=template&id=005bbbc8"
import script from "./v-loading.vue?vue&type=script&lang=js"
export * from "./v-loading.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__